import { Accordion as MuiAccordion, AccordionDetails, AccordionProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';
import { AccordionSummary } from './accordionSummary';

const StyledAccordion = styled(MuiAccordion, {
  shouldForwardProp: (prop) => prop !== 'withBorder'
})<{ withBorder?: boolean }>(({ theme, withBorder }) => ({
  position: 'relative',
  boxShadow: 'none',
  textAlign: 'center',
  backgroundColor: 'none',
  '&.MuiPaper-root:before': {
    display: 'none'
  },
  ...(withBorder
    ? {
        '&:after': {
          content: `""`,
          width: 'calc(100% - 96px)',
          height: '3px',
          left: '24px',
          bottom: '0',
          borderBottom: `1px solid ${theme.palette.grey['50']}`,
          position: 'absolute',
          backgroundColor: 'none'
        }
      }
    : {})
}));

export type Row = {
  mainText: string;
  secondaryText?: string;
};

type Props = {
  headlineData: Row;
  // renderContent: () => JSX.Element;
  withBorder?: boolean;
  withHeadlinePadding?: boolean;
  startIcon?: JSX.Element;
} & AccordionProps;

export const Accordion: FC<Props> = ({
  headlineData,
  // renderContent,
  withBorder,
  withHeadlinePadding,
  startIcon,
  children,
  ...accordionProps
}) => {
  return (
    <StyledAccordion disableGutters withBorder={withBorder} {...accordionProps}>
      <AccordionSummary
        headlineData={headlineData}
        withPadding={withHeadlinePadding}
        startIcon={startIcon}
      />
      <AccordionDetails sx={{ padding: '0px' }}>{children}</AccordionDetails>
    </StyledAccordion>
  );
};
